import { FullName, passwordString } from "#models/User"
import * as S from "effect-app/Schema"

/*
 * Form schema extends UpdateMe with a passwordConfirmation field
 * for client-side validation. The confirmation is stripped before submit.
 * password uses the API complexity rule so a weak password is a field error,
 * not a SchemaError thrown by Password() on submit (MACS-CONFIGURATOR-BE-HJ).
 */
export class UserForm extends S.Opaque<UserForm>()(
  S
    .Struct({
      name: FullName,
      email: S.Email,
      password: S.optional(S.Union([S.Literal(""), passwordString])),
      passwordConfirmation: S.optional(S.String)
    })
    .annotate({ identifier: "UserForm" })
) {}
